// extracted by mini-css-extract-plugin
export default {"blackBtn":"BlackButton_blackBtn__0dzla","button":"BlackButton_button__RK+-O"};